import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Field, reduxForm } from 'redux-form'
import { SelectField, SingleFilePickerField } from '../../components'
import { Button } from '../../elements'

import validate from './validate'

class DetectablesForm extends Component {
  static propTypes = {
    onSubmit: PropTypes.func,
  }

  render() {
    const { isSubmiting, handleSubmit, onSubmit, clients } = this.props
    let clientIds = clients.map(client => client.clientId);

    return (
      <form onSubmit={handleSubmit(onSubmit)}>
        <Field
          name="type"
          label="Type"
          id="type"
          options={['Detectables', 'Holder']}
          disabled={isSubmiting}
          component={SelectField}
        />

        <Field
          name="clientId"
          label="Client Id"
          id="clientId"
          options={clientIds}
          disabled={isSubmiting}
          component={SelectField}
        />

        <Field
          name="file"
          label="File"
          id="file"
          disabled={isSubmiting}
          component={SingleFilePickerField}
        />

        <Button loading={isSubmiting} htmlType="submit" type="primary">
          Import
        </Button>
      </form>
    )
  }
}

export default reduxForm({
    form: 'detectables-form',
    validate,
})(DetectablesForm)



// WEBPACK FOOTER //
// ./src/smart-components/detectables-form/index.js